import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from '../../settings';
import * as moment from 'moment';
import { SignalRConnection, BroadcastEventListener, ConnectionStatus, ConnectionStatuses } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';

@Injectable()
export class OrderstatusService {

  private hub: SignalRConnection;
  private _subcription: any;
  constructor(private _dashboardService: DashboardService,
    private _commonService: CommonService) { }

  UnitsPie(): any {
    return {
      resize: { silent: false },
      title: {
        show: true,
        text: 'Units',
        textAlign: 'center',
        textBaseline: 'bottom',
        bottom: '-1%',
        left: 'center',
        textStyle: {
          color: '#ccc',
          fontWeight: 'lighter',
          fontSize: 14
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: 'horizontal',
        top: 0,
        left: 0,
        // x: 'left',
        data: ['OnHold', 'Entered', 'Committed', 'Planned', 'Released', 'Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'],
        icon: 'circle',
        textStyle: {
          color: '#999',
        },
      },
      //color:['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],
      series: [{
        name: 'Units',
        itemStyle: {
          normal: {
            label: {
              formatter: '{c} \n ({d}%)',
              position: 'outside',
            },
            labelLine: {
              show: true
            }
          },
        },
        type: 'pie',
        //selectedMode: 'single',
        radius: ['40%', '70%'],
        label: {
          normal: {
            position: 'outside',
            offset: [-50, 50]
          },
          emphasis: {
            show: true,
            position: 'center',
            textStyle: {
              fontSize: '18',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: [{

        }]
      }]
    };
  }

  OrdersPie(): any {
    return {
      draggable: false,
      resizable: false,
      loading: false,
      style: {},
      title: {
        show: true,
        text: 'Orders',
        textAlign: 'center',
        textBaseline: 'bottom',
        bottom: '-1%',
        left: 'center',
        textStyle: {
          color: '#ccc',
          fontWeight: 'lighter',
          fontSize: 14
        }
      },
      label: {
        normal: {
          show: true
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: 'horizontal',
        top: 0,
        left: 0,
        data: ['OnHold', 'Entered', 'Committed', 'Planned', 'Released', 'Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'],
        icon: 'circle',
        textStyle: {
          color: '#999999',
        },
      },
      //color:['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'],

      series: [{
        name: 'Orders',
        itemStyle: {
          normal: {
            label: {
              formatter: '{c} \n ({d}%)',
              position: 'outside',
            },
            labelLine: {
              show: true
            }
          }
        },
        type: 'pie',
        //selectedMode: 'single',
        radius: ['40%', '70%'],
        label: {
          normal: {
            position: 'outside',
            testStyle: {
              fontSize: 5
            },
            offset: [-50, 50]
          },
          emphasis: {
            show: true,
            position: 'center',
            textStyle: {
              fontSize: '18',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: []
      },
      ]
    };
  }

  init(widget: any) {
    console.log('OrderstatusService')
    widget.dataLoaded = false;
    let currentDateTime = moment().toDate().getTime();
    widget.Title = 'Order Status';
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor('broadcastOrderStatus')
          .subscribe((result: any) => {
            console.log('broadcastOrderStatus' + widget.widgetId, result);
            if (result.widgetid == widget.widgetId && result.widgetcreationtime == widget.widgetcreationtime) {
              widget.dataLoaded = false;
              let Series1: Array<any> = [];
              if (result.PickType == "PreShip") {
                Series1.push({ value: result.OrdersOnHold, name: 'OnHold', selected: true });
                Series1.push({ value: result.OrdersEntered, name: 'Entered' });
                Series1.push({ value: result.OrdersCommitted, name: 'Committed' });
                Series1.push({ value: result.OrdersPlanned, name: 'Planned' });
                Series1.push({ value: result.OrdersReleased, name: 'Released' });
              }
              if (result.PickType == "PostShip") {
                Series1.push({ value: result.OrdersPicking, name: 'Picking' });
                Series1.push({ value: result.OrdersPicked, name: 'Picked' });
                Series1.push({ value: result.OrdersLoading, name: 'Loading' });
                Series1.push({ value: result.OrdersLoaded, name: 'Loaded' });
                Series1.push({ value: result.OrdersShipped, name: 'Shipped' });
              }
              if (result.PickType == "Both") {
                Series1.push({ value: result.OrdersOnHold, name: 'OnHold', selected: true });
                Series1.push({ value: result.OrdersEntered, name: 'Entered' });
                Series1.push({ value: result.OrdersCommitted, name: 'Committed' });
                Series1.push({ value: result.OrdersPlanned, name: 'Planned' });
                Series1.push({ value: result.OrdersReleased, name: 'Released' });
                Series1.push({ value: result.OrdersPicking, name: 'Picking' });
                Series1.push({ value: result.OrdersPicked, name: 'Picked' });
                Series1.push({ value: result.OrdersLoading, name: 'Loading' });
                Series1.push({ value: result.OrdersLoaded, name: 'Loaded' });
                Series1.push({ value: result.OrdersShipped, name: 'Shipped' });
              }
              let Series2: Array<any> = [];
              if (result.PickType == "PreShip") {
                Series2.push({ value: result.UnitsOnHold, name: 'OnHold', selected: true });
                Series2.push({ value: result.UnitsEntered, name: 'Entered' });
                Series2.push({ value: result.UnitsCommitted, name: 'Committed' });
                Series2.push({ value: result.UnitsPlanned, name: 'Planned' });
                Series2.push({ value: result.UnitsReleased, name: 'Released' });
              }
              if (result.PickType == "PostShip") {
                Series2.push({ value: result.UnitsPicking, name: 'Picking' });
                Series2.push({ value: result.UnitsPicked, name: 'Picked' });
                Series2.push({ value: result.UnitsLoading, name: 'Loading' });
                Series2.push({ value: result.UnitsLoaded, name: 'Loaded' });
                Series2.push({ value: result.UnitsShipped, name: 'Shipped' });
              }
              if (result.PickType == "Both") {
                Series2.push({ value: result.UnitsOnHold, name: 'OnHold', selected: true });
                Series2.push({ value: result.UnitsEntered, name: 'Entered' });
                Series2.push({ value: result.UnitsCommitted, name: 'Committed' });
                Series2.push({ value: result.UnitsPlanned, name: 'Planned' });
                Series2.push({ value: result.UnitsReleased, name: 'Released' });
                Series2.push({ value: result.UnitsPicking, name: 'Picking' });
                Series2.push({ value: result.UnitsPicked, name: 'Picked' });
                Series2.push({ value: result.UnitsLoading, name: 'Loading' });
                Series2.push({ value: result.UnitsLoaded, name: 'Loaded' });
                Series2.push({ value: result.UnitsShipped, name: 'Shipped' });
              }

              widget.UnitsPie = this.UnitsPie();
              widget.OrdersPie = this.OrdersPie();
              widget.errorMessage = null;
              widget.UnitsPie.series[0].data = Series2;
              widget.OrdersPie.series[0].data = Series1;
              widget.IfNoDataFound = result.IsNoDataFound;
              if (widget.IfNoDataFound) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }

              if (result.PickType == 'PreShip') {
                widget.UnitsPie.color = ['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b'];
                widget.OrdersPie.color = ['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b'];

                widget.UnitsPie.legend.data = ['OnHold', 'Entered', 'Committed', 'Planned', 'Released'];
                widget.OrdersPie.legend.data = ['OnHold', 'Entered', 'Committed', 'Planned', 'Released'];
              }
              else if (result.PickType == 'PostShip') {
                widget.UnitsPie.color = ['#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'];
                widget.OrdersPie.color = ['#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'];

                widget.UnitsPie.legend.data = ['Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'];
                widget.OrdersPie.legend.data = ['Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'];
              }
              else {
                widget.UnitsPie.color = ['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'];
                widget.OrdersPie.color = ['#575560', '#998675', '#c7b299', '#f7935a', '#fbb03b', '#8cc63f', '#44bd54', '#22b573', '#29abe2', '#0080a8'];

                widget.UnitsPie.legend.data = ['OnHold', 'Entered', 'Committed', 'Planned', 'Released', 'Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'];
                widget.OrdersPie.legend.data = ['OnHold', 'Entered', 'Committed', 'Planned', 'Released', 'Picking', 'Picked', 'Loading', 'Loaded', 'Shipped'];
              }

              //console.log(result)  ;
              widget.dataLoaded = true;
              this._commonService.lastUpdatedTime = result.LastUpdateTime;
            }
          }
            , err => {
              console.log('listenFor broadcastOrderStatus error', err);
            }
          );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "ORDERSTATUS";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })

      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });

  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.UnitsPie = this.UnitsPie();
    widget.OrdersPie = this.OrdersPie();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "orderStatus",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
            //do nothing
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "ORDERSTATUS";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "orderStatus",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
            //do nothing
          }
          console.log('deleteWidget orderstatus RemoveWidget');
        });
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/orderstatus.service.ts